import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
import { useRouter } from '../../../router';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Box, Button, Checkbox, Container, Divider, FormField, Link, Modal, Pagination, SegmentedControl, SpaceBetween, Spinner, Table, TextFilter } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiAlertOctagon, mdiCheckCircle, mdiFileExcel, mdiLayersSearchOutline, mdiRefresh, mdiWallet } from '@mdi/js';
import Icon from '@mdi/react';
import { format } from 'date-fns';
import BadgeCustom from '../../../../../components/extras/BadgeCustom';
import Favorites from '../../../../../components/extras/Favorites';
import SelectPaging from '../../../../../components/selects/selectPaging';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnIconForm, ItemUser } from '../../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, exportToExcel, formatCurrency, formatPhone, getCookie, getUrlVersion, setData, setLoading, setParameters } from '../../../../commons/functions';


type ItemUserEnable = {
    idUser: number;
    name: string;
    lastName: string;
    RUT: string;
    phone1: string;
    email: string;
    CPVLoading: boolean;
    CPSLoading: boolean;
    CPV: number;
    CPS: number;
    CPVEnabled: number;
    CPSEnabled: number;
    debt: number;
}

export const CommPollsEnablePage = () => {
    const { menu, parameters } = useGlobalState();
    const [users, setUsers] = useState<ItemUserEnable[]>([]);
    const [loadingSmall, setLoadingSmall] = useState<boolean>(false);
    const [filteringText, setFilteringText] = useState("");
    const [whatsApp, setWhatsApp] = useState(0);
    const [user, setUser] = useState<any>();
    const [missing, setMissing] = useState<number>(0);
    useGlobalState();
    const { navigate } = useRouter();
    useEffect(() => {
        let timeoutId: ReturnType<typeof setTimeout>;

        const runTask = async () => {
            try {
                await handleGetUsers(2);
            } catch (error) {
                console.error("Error in handleGetUsers:", error);
            } finally {
                timeoutId = setTimeout(runTask, 10000);
            }
        };
        timeoutId = setTimeout(runTask, 10000);
        return () => clearTimeout(timeoutId);
    }, []);
    const handleGetUser = async (idUser: number) => {
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/polls/userprofile',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({ idUser: idUser }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            if (data.code == 0) {
                setUser(data.user);
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally {
            setLoading(false)
        }

    }

    const handleGetUsers = async (loader: number) => {
        try {
            if (loader === 1) {
                setLoading(true)
            } else if (loader === 2) {
                setLoadingSmall(true);
            }
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/polls/enabled',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({}),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                setUsers(data.users.map((u: ItemUser) => ({ ...u, CPVLoading: false, CPSLoading: false })));
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally {
            if (loader === 1) {
                setLoading(false)
            } else if (loader === 2) {
                setLoadingSmall(false);
            }
        }

    }
    const handleGetUsersFilter = async (body: any) => {
        try {
            if (body.idGroup === 2209071) {
                setUsers(prev => prev.map(u => u.idUser === body.idUser ? { ...u, CPVLoading: true } : u))
            }
            if (body.idGroup === 2209072) {
                setUsers(prev => prev.map(u => u.idUser === body.idUser ? { ...u, CPSLoading: true } : u))
            }
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/polls/enable',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify(body),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                setUsers((prevUsers) =>
                    prevUsers.map((user) =>
                        user.idUser === data.users[0].idUser ? data.users[0] : user
                    )
                );
                //setUsers(data.users);
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally {

            if (body.idGroup === 2209071) {
                setUsers(prev => prev.map(u => u.idUser === body.idUser ? { ...u, CPVLoading: false } : u))
            }
            if (body.idGroup === 2209072) {
                setUsers(prev => prev.map(u => u.idUser === body.idUser ? { ...u, CPSLoading: false } : u))
            }

        }

    }

    /*
        const sortedUsers = [...users].sort((a, b) => {
            // 1. Sort by lastName first
            const lastNameCompare = a.lastName.localeCompare(b.lastName, 'es', { sensitivity: 'base' });
            if (lastNameCompare !== 0) {
                return lastNameCompare;
            }
            return a.name.localeCompare(b.name, 'es', { sensitivity: 'base' });
        });
        */
    useEffect(() => {
        handleGetUsers(1);
    }, []);


    const [currentPageIndex, setCurrentPageIndex] = useState(1);


    const filtered: ItemUserEnable[] = users.filter((item) => {
        // 1. Missing Logic
        if (missing === 1) {
            // Filter: CPV and CPS must both be 0
            if (!(item.CPVEnabled === 0 && item.CPSEnabled === 0)) return false;
        } else if (missing === -1) {
            // Filter: At least one of CPV or CPS must be 1
            if (!(item.CPVEnabled === 1 || item.CPSEnabled === 1)) return false;
        }
        // If missing === 0, we do nothing (all items pass this check)

        // 2. Text Search Logic
        const searchWords = filteringText.toLowerCase().split(/\s+/).filter(Boolean);
        const searchableFields = [
            item.name,
            item.RUT,
            item.lastName,
            item.phone1,
            item.email
        ];

        // Safely create the searchable text string
        const text = searchableFields
            .map(val => (val ?? "").toString().toLowerCase())
            .join(" ")
            .replace(/[^a-z0-9]/g, "");

        return searchWords.every((word) => text.includes(word.replace(/[^a-z0-9]/g, "")));
    });
    const paginated = filtered.slice((currentPageIndex - 1) * parameters.pageSize, currentPageIndex * parameters.pageSize);
    const CPS = users.filter(u => u.CPS === 1).length;
    const CPV = users.filter(u => u.CPV === 1).length;
    const CPSEnabled = users.filter(u => u.CPSEnabled === 1).length;
    const CPVEnabled = users.filter(u => u.CPVEnabled === 1).length;


    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">

                    <Header variant="h1" actions={
                        <SpaceBetween direction="horizontal" size="xs">

                            <SegmentedControl
                                options={[
                                    { id: "0", text: "Todos" },
                                    { id: "1", text: "Faltantes" },
                                    { id: "-1", text: "Habilitados" },
                                ]}
                                onChange={(e) => {
                                    setMissing(parseInt(e.detail.selectedId))
                                }}
                                selectedId={missing.toString()}
                            />
                            <Favorites />
                        </SpaceBetween>
                    } description={`${filtered.length !== users.length ? `${filtered.length}/` : ""}${users.length} usuarios`}>
                        Padrón electoral {loadingSmall ? <Spinner /> : null}</Header>
                    <Table
                        variant='embedded'
                        filter={
                            <SpaceBetween size="xs" direction="vertical">
                                <SpaceBetween size="xs" direction="horizontal">
                                    <TextFilter filteringText={filteringText} onChange={(e) => {
                                        setFilteringText(e.detail.filteringText)
                                        setCurrentPageIndex(1);
                                    }}
                                        filteringPlaceholder='Filtrar'
                                    />
                                    <Button style={{ root: btnIconForm }} onClick={() => {
                                        setCurrentPageIndex(1);
                                        setUsers([]);
                                        setFilteringText("")
                                        handleGetUsers(1);
                                    }} ><Icon path={mdiRefresh} size={1} /></Button>

                                    <Button style={{ root: btnIconForm }} disabled={users.length === 0} onClick={() => exportToExcel(users, "Padrón Electoral", format(new Date(), "dd-MM-yyyy HH:mm:ss"))}><Icon path={mdiFileExcel} size={1} /></Button>



                                </SpaceBetween>
                                <Checkbox checked={whatsApp === 1} onChange={(e) => {
                                    setWhatsApp(e.detail.checked ? 1 : 0);
                                }}>Notificar </Checkbox>
                            </SpaceBetween>
                        }


                        pagination={

                            <SpaceBetween direction="horizontal" size="xs" alignItems="center">
                                {filtered.length > parameters.pageSize && (
                                    <Pagination
                                        currentPageIndex={currentPageIndex}
                                        pagesCount={Math.ceil(filtered.length / parameters.pageSize)}
                                        onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
                                    />
                                )}

                                {filtered.length > 0 && filtered.length > parameters.pageSize && (
                                    <SelectPaging onSelect={(pageSize) => {
                                        setCurrentPageIndex(1);
                                        setParameters({ ...parameters, pageSize: pageSize });
                                    }} />
                                )}
                            </SpaceBetween>
                        }

                        columnDefinitions={[
                            {
                                id: 'rut',
                                header: 'RUT',
                                cell: (item) => <FormField label={item.RUT}>{item.idUser} <Link onClick={() => handleGetUser(item.idUser)}><Icon path={mdiLayersSearchOutline} size={0.75} /></Link></FormField>,
                            },
                            {
                                id: 'name',
                                header: 'Apellido/Nombre',
                                cell: (item) => <FormField label={item.lastName}>{item.name}</FormField>,
                            },
                            {
                                id: 'contact',
                                header: 'Email/Fono',
                                cell: (item) => <FormField label={item.email}>{formatPhone(item.phone1)}</FormField>,
                            },
                            {
                                id: 'D45',
                                width: 50,
                                header: "D45",
                                cell: (item) => item.debt < -10000 ?
                                    <Icon path={mdiWallet} size={1} color='orange' /> : null
                            },
                            {
                                id: 'CPV',
                                width: 50,
                                header: <FormField label={"CPV"} constraintText={`${CPV}/${CPVEnabled}`} />,
                                cell: (item) => item.CPVLoading ? <Spinner /> : <Checkbox
                                    disabled={item.CPV !== 1}
                                    checked={item.CPVEnabled === 1} onChange={(e) => {
                                        const body = {
                                            idUser: item.idUser,
                                            idGroup: 2209071,
                                            idPoll: 14,
                                            enable: e.detail.checked ? 1 : 0,
                                            loading: item.CPVLoading,
                                            whatsApp: whatsApp
                                        }
                                        handleGetUsersFilter(body);

                                    }} />
                            },
                            {
                                id: 'CPS',
                                width: 50,
                                header: <FormField label={"CPS"} constraintText={`${CPS}/${CPSEnabled}`} />,
                                cell: (item) => item.CPSLoading ? <Spinner /> : <Checkbox
                                    disabled={item.CPS !== 1}
                                    checked={item.CPSEnabled === 1} onChange={(e) => {
                                        const body = {
                                            idUser: item.idUser,
                                            idGroup: 2209072,
                                            idPoll: 15,
                                            enable: e.detail.checked ? 1 : 0,
                                            loading: item.CPSLoading,
                                            whatsApp: whatsApp
                                        }
                                        handleGetUsersFilter(body);
                                    }} />
                            },
                        ]}
                        items={paginated}
                    />
                    <Modal size='medium' visible={!!user} onDismiss={() => setUser(null)} closeAriaLabel="Close modal" header={`Perfil`}
                        footer={
                            <Box float="right">
                                <Button variant="link" onClick={() => setUser(null)}>Cerrar</Button>
                            </Box>}

                    >
                        <SpaceBetween direction="vertical" size="xs">
                            <h3>{user?.lastName}, {user?.name}</h3>
                            <Container header={<Header>Información de contacto</Header>}>
                                <SpaceBetween direction="horizontal" size="l">
                                    <FormField label="RUT">{user?.RUT}</FormField>
                                    <FormField label="ID Usuario">{user?.idUser}</FormField>
                                </SpaceBetween>
                                <SpaceBetween direction="horizontal" size="xs">
                                    <FormField label="Email">{user?.email}</FormField>
                                    <FormField label="Teléfono">{formatPhone(user?.phone1)}</FormField>
                                </SpaceBetween>
                            </Container>
                            <Container header={<Header description={"Pagos por combustible ignorados"}>Estado financiero</Header>}
                                media={{
                                    content: <Icon path={user?.balance?.debt > -10000 ? mdiCheckCircle : mdiAlertOctagon} size={4}
                                        color={user?.balance?.debt > -10000 ? "green" : "red"}
                                    />,
                                    position: "side",
                                    width: "20%"
                                }}>
                                <SpaceBetween direction="horizontal" size="l">
                                    <FormField
                                        label="Saldo actual">{formatCurrency(user?.balance?.balance, "CLP")}</FormField>

                                    <FormField
                                        label="Deuda vencida" constraintText={"A 45 días"}>{formatCurrency(user?.balance?.debt, "CLP")}</FormField>

                                </SpaceBetween>
                            </Container>
                            <Container header={<Header description={"Debe cumplir al menos 1/2"}>Requisitos para habilitación CPS</Header>}
                                media={{
                                    content: <Icon path={user?.dateMemberDays > 3650 || (user?.HH / 60) >= 150 ? mdiCheckCircle : mdiAlertOctagon} size={4}
                                        color={user?.dateMemberDays > 3650 || (user?.HH / 60) >= 150 ? "green" : "red"}
                                    />,
                                    position: "side",
                                    width: "20%"
                                }}
                            >
                                <SpaceBetween direction="horizontal" size="l">
                                    <FormField
                                        info={<Link>Días</Link>}
                                        constraintText={user?.dateMemberDays > 3650 ? <BadgeCustom size="small" color='green'>Cumple</BadgeCustom> : <BadgeCustom size="small" color='red'>No cumple</BadgeCustom>}
                                        label="Antiguedad">{user?.dateMemberDays} / 3650</FormField>
                                    <Divider />
                                    <FormField
                                        info={<Link>Horas</Link>}
                                        constraintText={(user?.HH / 60) >= 150 ? <BadgeCustom size="small" color='green'>Cumple</BadgeCustom> : <BadgeCustom size="small" color='red'>No cumple</BadgeCustom>}
                                        label="HT Planeador">{(user?.HH / 60).toFixed(2)} / 150</FormField>

                                </SpaceBetween>
                            </Container>
                        </SpaceBetween>

                    </Modal >
                </SpaceBetween >
            }
        />
    )
};
